import React, { useMemo } from 'react';

import TextField from '@mui/material/TextField';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { NumberInput } from '../NumberInput';

export const Name = () => {
  return (
    <TextField
      margin="dense"
      id="name"
      name="name"
      label="Name"
      autoFocus
      required
      fullWidth
    />
  );
};

export const Phone = () => {
  return (
    <TextField
      margin="dense"
      id="phone"
      name="phone"
      label="Phone"
      type="tel"
      required
      fullWidth
    />
  );
};

export const Email = () => {
  return (
    <TextField
      margin="dense"
      id="email"
      name="email"
      label="Email"
      type="email"
      required
      fullWidth
    />
  );
};

export const CheckInCheckOut: React.FC<{
  checkin: Date | null;
  setCheckin: (date: Date) => void;
  checkout: Date | null;
  setCheckout: (date: Date) => void;
}> = ({ checkin, setCheckin, checkout, setCheckout }) => {
  const minCheckout = useMemo(() => {
    if (!checkin) {
      return new Date(new Date().setDate(new Date().getDate() + 1));
    }

    return new Date(new Date().setDate(checkin.getDate() + 1));
  }, [checkin]);

  return (
    <div style={{ display: 'flex' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Check In"
          value={checkin}
          minDate={new Date()}
          onChange={(newValue: Date | null) => {
            if (newValue) {
              setCheckin(newValue);
            }
          }}
          onAccept={(newValue: Date | null) => {
            if (newValue) {
              setCheckin(newValue);
            }
          }}
          renderInput={(params: any) => (
            <TextField
              style={{ flex: 1 }}
              margin="dense"
              required
              {...params}
            />
          )}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Check Out"
          value={checkout}
          minDate={minCheckout}
          onChange={(newValue: Date | null) => {
            if (newValue) {
              setCheckout(newValue);
            }
          }}
          onAccept={(newValue: Date | null) => {
            if (newValue) {
              setCheckout(newValue);
            }
          }}
          renderInput={(params: any) => (
            <TextField
              style={{ flex: 1 }}
              margin="dense"
              required
              {...params}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export const Adults: React.FC<{
  adults: number;
  setAdults: (adults: number) => void;
}> = ({ adults, setAdults }) => {
  return (
    <NumberInput
      value={adults}
      name="Adults"
      min={1}
      onChange={(v: number) => setAdults(v)}
    />
  );
};

export const Children: React.FC<{
  children: number;
  setChildren: (children: number) => void;
}> = ({ children, setChildren }) => {
  return (
    <NumberInput
      value={children}
      name="Children"
      min={0}
      onChange={(v: number) => setChildren(v)}
    />
  );
};

export const Rooms: React.FC<{
  rooms: number;
  setRooms: (children: number) => void;
}> = ({ rooms, setRooms }) => {
  return (
    <NumberInput
      value={rooms}
      name="Rooms"
      min={1}
      onChange={(v: number) => setRooms(v)}
    />
  );
};

export const Staff = () => {
  return (
    <TextField
      margin="dense"
      id="staff"
      name="staff"
      label="Staff"
      type="staff"
      fullWidth
    />
  );
};

export const Notes = () => {
  return (
    <TextField
      margin="dense"
      id="notes"
      name="notes"
      label="Notes"
      type="notes"
      minRows="3"
      multiline
      fullWidth
    />
  );
};
